
export default function RomDataBank(opts) {
    // 0x000-0x0ff ctl
    // 0x100-0x1ff window

    const buf = opts.data;

    let window;

    const dataAddress = (offset) => {
        
        const b0 = (window & 0xff0000) >> 16;
        const b1 = (window & 0x00ff00) >> 8;
        const b2 = (window & 0x0000ff) >> 0;
        const win = (b0 << 16) | (b1 << 8) | (b2);
        return ((win << 8) | offset ) >>> 0;
        //return (((window << 8) | offset) >>> 0);
    }

    const read = (address) => {

        if (address < 3) {
            return ((window >> (address*8)) & 0xff) >>> 0;
        } else if (address < 256) {
            return 0;
        } else { 
            const da = dataAddress(address - 256);
          //  console.log(da);
            if (da < buf.length) {
                return buf.readUInt8(da);
            } else {
                return 0;
            }
        }
    };

    const write = (address, value) => {
        if (address < 3) {
            const delMask = ~(0xff << (address*8)) >>> 0;
            window &= delMask;
            window |= (value << (address*8)) >>> 0;
        }
    };

    const reset = () => {
        window = 0;
    };

    reset();

    return {
        read: read,
        write: write,
        reset: reset
    }
}


// WEBPACK FOOTER //
// ./src/emu/rom-data-bank.js